import BlankCoupon from '@components/blank/BlankCoupon';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';

import useMyCoupons from './hooks/useMyCoupons';
import styles from './styles.module.scss';
import CouponFilter from '../../components/CouponFilter';
import CouponItem from '../../components/CouponItem';

function MyCouponFragment() {
  const {
    coupons, fetchNext, isEmpty, setSort, sort, status,
  } = useMyCoupons();
  return (
      <Column fullWidth>
          <CouponFilter sort={sort} setSort={setSort}/>
          <Column fullWidth as='section'
                  align='center'
                  spacing={16}
                  className={styles.container} >
              {coupons.map((coupon, i) => (
                  <CouponItem coupon={coupon}
                              key={coupon.couponId} />
              ))}
              {isEmpty && (
                  <BlankCoupon/>
              )}
              <InfinityScrollTrigger trigger={fetchNext} />
              {status === 'pending' && (
                  <Loading size='small'/>
              )}
          </Column>
      </Column>
  );
}

export default MyCouponFragment;
